import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { PageMeta, PageMetaService, urlPathJoin, WindowRef } from '@spartacus/core';
import { SchemaBuilder } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomBreadcrumbSchemaBuilder implements SchemaBuilder {
  constructor(
    protected pageMetaService: PageMetaService,
    private winRef: WindowRef,
    private baseStoreFacade: BaseStoreFacade,
  ) {}

  build(): Observable<any> {
    return combineLatest({
      baseStoreCode: this.baseStoreFacade.getActiveCode(),
      pageMeta: this.pageMetaService.getMeta(),
    }).pipe(
      map(({ baseStoreCode, pageMeta }) => {
        return this.collect(pageMeta, baseStoreCode);
      }),
    );
  }

  protected collect(pageMeta: PageMeta, baseStoreCode: string): any {
    if (!pageMeta?.breadcrumbs) {
      return;
    }
    const lastElementIndex = pageMeta.breadcrumbs.length - 1;
    const baseUrl = urlPathJoin(this.winRef.location.origin, baseStoreCode);
    const crumbs = pageMeta.breadcrumbs.map((crumb, index) => {
      let link: string;
      if (index === lastElementIndex) {
        link = pageMeta.canonicalUrl;
      } else {
        link = urlPathJoin(baseUrl, crumb.link === '/' ? '' : crumb.link);
      }

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': link,
          name: crumb.label,
        },
      };
    });

    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs,
    };
  }
}
